import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

interface RevenueChartProps {
  data?: Array<{ month: string; revenue: number; sales: number }>;
  height?: number;
}

const RevenueChart: React.FC<RevenueChartProps> = ({
  data = [
    { month: 'Jan', revenue: 40000, sales: 2400 },
    { month: 'Feb', revenue: 30000, sales: 1398 },
    { month: 'Mar', revenue: 20000, sales: 9800 },
    { month: 'Apr', revenue: 27800, sales: 3908 },
    { month: 'May', revenue: 18900, sales: 4800 },
    { month: 'Jun', revenue: 23900, sales: 3800 },
  ],
  height = 320,
}) => {
  const chartOptions: ApexOptions = {
    chart: {
      type: 'line',
      toolbar: {
        show: false,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
        },
      },
      sparkline: {
        enabled: false,
      },
    },
    stroke: {
      curve: 'smooth',
      width: [3, 2],
    },
    colors: ['#0284c7', '#06b6d4'],
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    markers: {
      size: 4,
      strokeWidth: 0,
      hover: {
        size: 6,
      },
    },
    xaxis: {
      categories: data.map((d) => d.month),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: '#6b7280',
          fontSize: '12px',
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: '#6b7280',
          fontSize: '12px',
          fontWeight: 500,
        },
      },
    },
    grid: {
      show: true,
      borderColor: '#e5e7eb',
      strokeDashArray: 4,
      padding: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 10,
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    tooltip: {
      theme: 'light',
      style: {
        fontSize: '12px',
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      fontSize: '12px',
      fontFamily: 'inherit',
      markers: {
        size: 4,
      },
    },
  };

  const series = [
    {
      name: 'Revenue',
      data: data.map((d) => d.revenue),
    },
    {
      name: 'Sales Count',
      data: data.map((d) => d.sales),
    },
  ];

  return (
    <ReactApexChart
      options={chartOptions}
      series={series}
      type="line"
      height={height}
      width="100%"
    />
  );
};

export default RevenueChart;
